// extracted by mini-css-extract-plugin
export var box = "_52-1";
export var checkboxRow = "_52-8";
export var checked = "_52-2";
export var descriptionSpacer = "_52-a";
export var disabled = "_52-3";
export var icon = "_52-6";
export var input = "_52-0";
export var labelSpacer = "_52-9";
export var medium = "_52-5";
export var small = "_52-4";
export var text = "_52-7";